<template>
<form id="search" action="/search" @submit.prevent="submitSearch" method="get">
  <div class="ff ff-align-between ff-nowrap">
    <div 
      class="search-query ff-fill bg-dark-grey ff ff-align-between ff-valign-center ff-content-center ff-nowrap" 
      v-bind:class="{ 'in-focus': inFocus }"
    >
      <icon name="icon-search" color="white" size=24 />
      <input 
        :value="q" 
        v-on:blur="updateOnBlur" 
        v-on:focus="updateOnFocus" 
        @input="updateOnInput" 
        type="search" 
        autocomplete="off" 
        title="Search" 
        spellcheck="false"
        class="ff-self-stretch ff-fill"
        placeholder="What are you looking for?"
        ref="input"
      >
      <transition name="fade">
        <div v-if="q && searchTotal > 0" class="search-total ff ff-center">
          {{ searchTotal }}
        </div>
      </transition>
      <div class="search-type ff-self-stretch ff ff-hide ff-sm-hide ff-auto">
        <div 
  v-on:click="updateShowTypes"
          class="search-type-selected ff ff-valign-center ff-nowrap ff-self-stretch"
        >
          <span class="ff-auto">Search:</span>
          <strong class="ff-auto">{{ searchType }}</strong>
          <icon name="ui-chevron-down" color="white" size=18 />
        </div>
        <transition name="fade">
          <div 
            v-show="showTypes"
            class="search-type-options"
          >
            <div class="ff bg-dark-grey">
              <div class="ff-12 search-type-option">
                <input 
                  v-model="searchType" 
                  v-on:change="updateOnTypeChange"
                  type="radio" 
                  id="type-everything" 
                  value="Tests and FAQ"
                >
                <label for="type-everything"><div class="ui-radio-button"><icon name="ui-tick" color="cyan" size=18 /></div><span>Tests and FAQ</span></label>
              </div>
              <div class="ff-12 search-type-option">
                <input 
                  v-model="searchType" 
                  v-on:change="updateOnTypeChange"
                  type="radio" 
                  id="type-faq" 
                  value="FAQ"
                >
                <label for="type-faq"><div class="ui-radio-button"><icon name="ui-tick" color="cyan" size=18 /></div><span>FAQ</span></label>
              </div>
              <div class="ff-12 search-type-option">
                <input 
                  v-model="searchType" 
                  v-on:change="updateOnTypeChange"
                  type="radio" 
                  id="type-tests" 
                  value="Tests"
                >
                <label for="type-tests"><div class="ui-radio-button"><icon name="ui-tick" color="cyan" size=18 /></div><span>Tests</span></label>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <button class="btn btn-search bg-cyan ff-auto" role="submit">
      Search
    </button>
    
    <transition name="fade">
      <div v-if="inFocus && (results.length > 0 || suggestions.length > 0)" id="autosearch" class="half-vertical-padding">
          
        <div v-if="results.length > 0" id="autosearch-results">
          <ul>
            <li v-for="(result,r) in results" :key="'result-'+r">
              <router-link :to="result.url" class="ff ff-valign-center ff-nowrap">
                <icon :name="'icon-'+result.icon" color="grey" size=18></icon>
                <span>
                  <span v-html="result.name"></span> <em v-if="result.is_package" class="grey">(Package: {{ result.category }})</em> <em v-else class="grey">({{ result.category }})</em>
                </span>
              </router-link>
            </li>
            
            <li class="search-show-more" :key="'result-show-more'">
              <button class="btn btn-search bg-black border-top border-dark-grey ff-12" role="submit">
                <span>Click here for more results</span>
                <icon name="ui-chevron-right" color="white" size=18 />
              </button>
            </li>
          </ul>
        </div>
        
        <div v-if="suggestions.length > 0" id="autosearch-suggestions">
          <ul>
            <li class="autosearch-title"><strong><em>Did you mean?</em></strong></li>
            <li v-for="(suggestion,s) in suggestions" :key="'suggestion-'+s">
              <span v-on:click="trySuggestion(suggestion.suggestion)">{{ suggestion.suggestion }}</span>
            </li>
          </ul>
        </div>
          
      </div>
    </transition>
  </div>
</form>
</template>

<script>
  export default {
    name: 'search',
    data() {
      return {
        searching: false,
        source: '',
        suggestions: [],
        results: []
      }
    },
    computed: {
      apiURL() {
        return this.$store.state.apiURL;
      },
      searchTotal() {
        return this.$store.state.search.total;
      },
      q() {
        var q = this.$store.state.search.query;
        return q;
      },
      searchType: {
        get () {
          return this.$store.state.search.type;
        },
        set (value) {
          this.$store.commit('setSearch', { key: 'type' , val: value });
        }
      },
      showTypes() {
        var showTypes = this.$store.state.search.showTypes;
        return showTypes;
      },
      inFocus() {
        var inFocus = this.$store.state.search.inFocus;
        return inFocus;
      }
    },
    methods: {
      blur: function() {
        this.$refs.input.blur();
      },
      focus: function() {
        this.$refs.input.focus();
      },
      updateOnFocus() {
        this.$store.commit('setSearch', { key: 'inFocus' , val: true });
        this.$store.commit('setSearch', { key: 'showTypes' , val: false });
      },
      updateOnBlur() {
        var v = this;
        
        // Set a timeout so people have enough time to click. Currently set to 500 milliseconds.
        setTimeout(function(){
          v.$store.commit('setSearch', { key: 'inFocus' , val: false });
        }, 500);
      },
      updateOnTypeChange() {
        this.$store.commit('setSearch', { key: 'showTypes' , val: false });
        
        if(this.$route.name !== "searchResults" && this.q.length > 2) {
          this.autoComplete();
          this.$refs.input.focus();
        }
      },
      updateShowTypes() {
        var showTypes = !this.$store.state.search.showTypes;
        this.$store.commit('setSearch', { key: 'showTypes' , val: showTypes });
      },
      trySuggestion(value) {
        this.$store.commit('setSearch', { key: 'query' , val: value });
        
        if(this.q.length > 2) {
          this.autoComplete();
        }
      },
      updateOnInput(e) {
        this.$store.commit('setSearch', { key: 'query' , val: e.target.value });
        
        if(this.q.length > 2) {
          this.autoComplete();
        } else {
          this.results = [];
          this.suggestions = [];
        }
        
      },
      async autoComplete() {
        // Cancel if searching
        if(this.searching) {
          this.source.cancel();
        }
        
        // Set the search query
        const searchParams = new URLSearchParams();
        searchParams.append('q', this.q);
        searchParams.append('limit', 5);
        
        // Reset cancel functionality
        this.searching = true;
        this.source = this.$axios.CancelToken.source();
        
        // Set the search API url
        let searchURL = 'search';
        
        if(this.searchType === 'FAQ') {
          searchURL = 'search/faq';
        } else if(this.searchType === 'Tests') {
          searchURL = 'search/tests';
        } else {
          searchURL = 'search';
        }
        
        // Request data from API
        await this.$axios.get(this.apiURL+searchURL, { cancelToken: this.source.token , params: searchParams }). then((response) => {
          
          if(response.data.results !== undefined) {
            this.results = response.data.results;
            this.suggestions = [];
          }
          
          if(response.data.suggestions !== undefined) {
            this.suggestions = response.data.suggestions;
            this.results = [];
          }
          
        // eslint-disable-next-line
        }, (error)  =>  {
          // eslint-disable-next-line
          console.log('Search error.');
        });
        
        this.searching = false;
        
      },
      submitSearch() {
        this.$store.commit('setSearch', { key: 'isSearching' , val: true });
        this.$refs.input.blur();
        
        if(this.$route.name !== "searchResults") {
          this.$router.push({ path: '/search' });
        }
        
        this.$gtm.trackEvent({
          'event': 'search',
          'action': 'submit',
          'search-term': this.q,
          'search-category': this.searchType
        });
      }
    }
  }
</script>